// Offer
(function ($) {
    function offer() {
        let offerList = $('.offer__properties-list');

        offerList.each(function () {
            let offerListName = $('.offer__properties-list-name', this);
            let offerListDescription = $('.offer__properties-list-description', this);

            offerListName.on('click', function(e) {

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).next('.offer__properties-list-description').slideUp(300);
                } else {
                    offerListName.removeClass('active');
                    offerListDescription.slideUp(300);
                    $(this).next('.offer__properties-list-description').slideDown(300);
                    $(this).addClass('active');
                }
            });

        });

        // Price Switcher
        $('.checkbox-switch-input, .checkbox-switch-input--mobile').on('click', function(){

            if ( $(this).is(':checked') ) {
                $(this).parents('.offer-3-col').find('.offer__price-wrapper--base').hide();
                $(this).parents('.offer-3-col').find('.offer__price-wrapper--plan').show();

                $(this).parents('.offer-3-col').find('.offer-3-col__plan-mobile .checkbox-switch-input--mobile, .offer-3-col__plan .checkbox-switch-input').prop('checked', true).attr('data-state', 'checked');
            } else {
                $(this).parents('.offer-3-col').find('.offer__price-wrapper--base').show();
                $(this).parents('.offer-3-col').find('.offer__price-wrapper--plan').hide();
                
                $(this).parents('.offer-3-col').find('.offer-3-col__plan-mobile .checkbox-switch-input--mobile, .offer-3-col__plan .checkbox-switch-input').prop('checked', false).attr('data-state', 'unchecked');
            }
        })

        $('.first_button').on('click', function (){
            $(this).parents('.offer-3-col').removeClass('switched');
            $(this).addClass('btn--primary').removeClass('btn--primary-outline');
            $(this).siblings().removeClass('btn--primary').addClass('btn--primary-outline');
        });

        $('.second_button').on('click', function (){
            $(this).parents('.offer-3-col').addClass('switched');
            $(this).addClass('btn--primary').removeClass('btn--primary-outline');
            $(this).siblings().removeClass('btn--primary').addClass('btn--primary-outline');
        });

        $('.offer-3-col.with-swiper').each(function(){
            $(this).find('.wp-block-columns .wp-block-column' ).wrapAll('<div class="swiper-wrapper">', '</div>');
            $(this).find('.wp-block-columns .wp-block-column' ).addClass('swiper-slide');

            $(this).find('.swiper-wrapper' ).wrap('<div class="swiper">', '</div>');

            let numberOfColumns = $(this).find('.wp-block-columns .wp-block-column' ).length;
            let initialSlidesPerView = 1.25;
            let slidesPerView = (numberOfColumns > 2 ) ? 1.25 : 2;
            let initialSlide = 1;

            if(numberOfColumns <= 2) {
                initialSlide = 0;
            }

            const id = $(this).attr('data-id');

            new Swiper('.offer-3-col[data-id="' + id + '"] .swiper', {
                spaceBetween: 16,
                slidesPerView: 1.25,
                direction: 'horizontal',
                centeredSlides: false,
                initialSlide: initialSlide,
                watchOverflow: true,
                slidesOffsetBefore: 10,
                slidesOffsetAfter: 10,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                        allowTouchMove: false,
                    }
                }
            });
        });

    }

    offer();

})(jQuery);